import {
	SET_ADMINS,
	SET_ADMIN,
	CLEAR_ADMINS,
	CLEAR_ADMIN,
	ADD_ADMIN,
	UPDATE_ADMIN,
	REMOVE_ADMIN,
} from './actionTypes';

export const admin = (state = {}, action) => {
	switch (action.type) {
		case SET_ADMIN:
			return action.payload;
		case UPDATE_ADMIN:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_ADMIN:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_ADMINS:
			return action.payload;
		case ADD_ADMIN:
			return [...state, action.payload];
		case UPDATE_ADMIN:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_ADMIN:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_ADMINS:
			return [];
		default:
			return state;
	}
};
